import styled from "styled-components";
export const NestedTooltipItem = styled.div(({ theme }) => ({
    borderLeft: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
    paddingLeft: theme.spacing.small,
    marginTop: theme.spacing.xSmall,
    paddingBottom: theme.spacing.xSmall,
}));
